import React from 'react';

import { useIntl } from 'react-intl';

import { useShouldShowThRewardsPointsHeader } from 'components/features/hooks/use-should-show-th-rewards-points-header';
import OnboardingCard from 'components/rewards/onboarding-card';
import RewardsHeader from 'components/rewards/rewards-header';
import { useLoyaltyActiveCard } from 'hooks/loyalty';
import { useAuthContext } from 'state/auth';
import { routes } from 'utils/routing';

import { TimsRewardsPointsSectionSkeleton } from './tims-rewards-points-section.skeleton';

export const TimsRewardsPointsSection = ({
  welcomeText,
  heroActionText,
  route = routes.timsRewards,
}: {
  welcomeText?: string;
  heroActionText?: string;
  route?: string;
}) => {
  const { formatMessage } = useIntl();
  const { loading: loyaltyLoading, loyaltyDetails } = useLoyaltyActiveCard();
  const { isAuthenticated, loading: authContextLoading } = useAuthContext();
  const authenticated = isAuthenticated();
  const isNotValidLoyaltyUser = !authenticated || !loyaltyDetails;
  const isLoading = loyaltyLoading || authContextLoading;
  const actionText = heroActionText ?? formatMessage({ id: 'details' });
  const shouldShowThRewardsPointsHeader = useShouldShowThRewardsPointsHeader();

  if (isNotValidLoyaltyUser || !shouldShowThRewardsPointsHeader) {
    return null;
  }

  if (isLoading) {
    return <TimsRewardsPointsSectionSkeleton />;
  }

  return (
    <>
      <RewardsHeader
        isLoading={isLoading}
        actionTo={route}
        actionText={actionText}
        descriptionText={welcomeText}
        loyaltyDetails={loyaltyDetails}
      />
      <OnboardingCard />
    </>
  );
};
